"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserStorageStore = void 0;
const store_1 = require("./store");
/**
 * Autoloading store based on the browsers local/session storage which synchronizes automatically across browser tabs and sessions
 */
class BrowserStorageStore extends store_1.Store {
    constructor(options, storage) {
        super(options.default);
        this.options = options;
        this.storage = storage;
        if (options.parser === undefined)
            options.parser = "string";
        // load initial value
        const initialValue = storage.getItem(options.key);
        if (initialValue !== null && initialValue !== undefined)
            this.setValue(this.parseValue(initialValue));
        else if (this.options.default)
            this.setValue(this.options.default);
        // react to changes from outside
        this.value$.subscribe((val) => {
            if (val === undefined)
                storage.removeItem(this.options.key);
            else
                storage.setItem(this.options.key, this.stringifyValue(val));
        });
        // react to changes from other tabs
        window.addEventListener("storage", (storageEvent) => {
            if (storageEvent.storageArea === this.storage && storageEvent.key === this.options.key)
                if (storageEvent.newValue === null)
                    this.setValue(this.options.default);
                else
                    this.setValue(this.parseValue(storageEvent.newValue));
        });
    }
    parseValue(val) {
        switch (this.options.parser) {
            case "json":
                return JSON.parse(val);
            case "number":
                return parseInt(val);
            case "boolean":
                return val === "true";
            case "string":
            default:
                return val;
        }
    }
    stringifyValue(val) {
        switch (this.options.parser) {
            case "json":
                return JSON.stringify(val);
            case "number":
                return "" + val;
            case "boolean":
                return "" + val;
            case "string":
            default:
                return val;
        }
    }
}
exports.BrowserStorageStore = BrowserStorageStore;
